import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip,
  Typography,
  useTheme,
  Box,
  Stack,
  Card,
} from "@mui/material";
import { Link, useOutletContext } from "react-router-dom";
import noDataFolder from "../../Assets/folder.png";
import axios from "axios";
import { Url } from "../../Api/Api";
import { getAccessToken } from "../../hooks/useLocalStorage";
import QuerySolutionPage from "./QuerySolutionPage";
import dayjs from "dayjs";
import { QueryTableRowSkeleton } from "../../components/adminComponents/SimulationActivity";

const statusColor = {
  Open: "warning",
  closed: "success",
};
const SupportIndex = () => {
  const theme = useTheme();
  const { drawerOpen } = useOutletContext();
  const drawerWidth = 10;
  const collapsedWidth = 240;

  const openGmailCompose = (email) => {
    const recipient = email; // Optional: pre-fill recipient
    const subject = ""; // Optional: pre-fill subject
    const body = ""; // Optional: pre-fill body

    // Encode components for URL safety
    const encodedRecipient = encodeURIComponent(recipient);
    const encodedSubject = encodeURIComponent(subject);
    const encodedBody = encodeURIComponent(body);

    // Construct the Gmail compose URL
    const gmailUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=${encodedRecipient}&su=${encodedSubject}&body=${encodedBody}`;

    // Open the URL in a new tab
    window.open(gmailUrl, "_blank");
  };

  const [open, setOpen] = React.useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const token = getAccessToken();

  const [adminDetails, setAdminDetails] = useState(null);

  const [loader, setLoader] = useState(false);

  const getAdminDetails = async () => {
    setLoader(true);
    try {
      const response = await axios.get(Url.GetAdminQueries, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setAdminDetails(response?.data);
    } catch (e) {
      console.log("error", e);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    getAdminDetails();
  }, []);

  const lableStyle = {
    fontSize: "16px",
    fontWeight: 500,
  };

  return (
    <>
      <Box sx={{ flexGrow: 1 }}>
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: 3,
            marginTop: 2,
            transition: theme.transitions.create("margin", {
              easing: theme.transitions.easing.sharp,
              duration: theme.transitions.duration.leavingScreen,
            }),
            marginLeft: `${drawerOpen ? drawerWidth : collapsedWidth}px`,
            ...(!drawerOpen && {
              transition: theme.transitions.create("margin", {
                easing: theme.transitions.easing.easeOut,
                duration: theme.transitions.duration.enteringScreen,
              }),
            }),
          }}
        >
          <Box sx={{ mb: 2 }}>
            <Typography
              variant="h4"
              fontWeight="bold"
              gutterBottom
              sx={{
                background:
                  theme.palette.mode === "light"
                    ? "linear-gradient(to right, #00bfff, #00bfff)"
                    : "linear-gradient(to right, #00bfff, #00bfff)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                display: "inline-block",
              }}
            >
              Support and Queries
            </Typography>
            <Typography variant="body1" color="#002147">
              View all Admins Queries and support history
            </Typography>
          </Box>
          <Card sx={{ p: 3 }}>
            <TableContainer
              component={Paper}
              sx={{
                borderRadius: 1,
                boxShadow: "10 20px 0px #eee",
                minHeight: 500,
              }}
            >
              <Table>
                <TableHead
                  sx={{
                    "& th": {
                      backgroundColor: "#51b0cfff",
                      color: "white",
                    },
                  }}
                >
                  <TableRow>
                    <TableCell sx={lableStyle}>S. No.</TableCell>
                    <TableCell sx={lableStyle}>Name</TableCell>
                    <TableCell sx={lableStyle}>Date</TableCell>
                    <TableCell sx={lableStyle}>Institution Name</TableCell>
                    <TableCell sx={lableStyle}>Query Type</TableCell>
                    <TableCell sx={lableStyle}>Status</TableCell>
                    <TableCell sx={lableStyle}>Email</TableCell>
                    <TableCell sx={lableStyle} align="center">
                      Action
                    </TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {loader ? (
                    Array.from({ length: 7 }).map((_, i) => (
                      <QueryTableRowSkeleton key={i} />
                    ))
                  ) : !adminDetails?.length ? (
                    <TableRow>
                      <TableCell colSpan={8}>
                        <Stack
                          minHeight={400}
                          textAlign="center"
                          justifyContent="center"
                          alignItems="center"
                        >
                          <img
                            src={noDataFolder}
                            height={"100px"}
                            width={"100px"}
                            alt="img"
                          />
                          <Typography>No data found</Typography>
                        </Stack>
                      </TableCell>
                    </TableRow>
                  ) : (
                    adminDetails.map((row, i) => (
                      <TableRow key={i} hover>
                        <TableCell>{i + 1}</TableCell>
                        <TableCell>{row.name ?? "-"}</TableCell>
                        <TableCell>
                          {dayjs(row.data).format("DD-MM-YYYY") ?? "-"}
                        </TableCell>
                        <TableCell>{row.institutionName ?? "-"}</TableCell>
                        <TableCell>{row.queryType ?? "-"}</TableCell>
                        <TableCell>
                          <Chip
                            size="small"
                            label={row.status ?? "-"}
                            color={statusColor[row.status] || "default"}
                            sx={{ width: "80px", textTransform: "capitalize" }}
                          />
                        </TableCell>
                        <TableCell
                          component={Link}
                          color="inherit"
                          underline="hover"
                          // sx={{ textDecoration: "none" }}
                          onClick={() => openGmailCompose(row.email)}
                        >
                          {row.emailId ?? "-"}
                          {/* </Link> */}
                        </TableCell>
                        <TableCell align="center">
                          <QuerySolutionPage
                            row={row}
                            getAdminDetails={getAdminDetails}
                          />
                        </TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Card>
        </Box>
      </Box>
    </>
  );
};

export default SupportIndex;
